import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCapital = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M6.419 6.208A8.75 8.75 0 0 1 21.25 12.5a.75.75 0 0 0 1.5 0c0-5.66-4.59-10.25-10.25-10.25-2.79 0-5.32 1.115-7.167 2.922v-1.38a.75.75 0 1 0-1.5 0v3.166c0 .415.336.75.75.75H7.75a.75.75 0 1 0 0-1.5H6.419Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M3.75 12.5a.75.75 0 0 0-1.5 0c0 5.66 4.59 10.25 10.25 10.25 2.79 0 5.32-1.115 7.167-2.922v1.38a.75.75 0 0 0 1.5 0v-3.166a.75.75 0 0 0-.75-.75H17.25a.75.75 0 0 0 0 1.5h1.331A8.75 8.75 0 0 1 3.75 12.5Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M8.91 12.56a.4.4 0 0 1 0-.392l3.105-5.545a.4.4 0 0 1 .698 0l3.107 5.545a.4.4 0 0 1 0 .392l-3.107 5.545a.4.4 0 0 1-.698 0l-3.106-5.546Zm2.064.615 1.39 2.484 1.442-2.574-.992.496a1.15 1.15 0 0 1-1.029 0l-.811-.406Zm2.73-1.716-1.34-2.39-1.367 2.441 1.303.651 1.404-.702Z"
    />
  </svg>
);
export default SvgTwoColorCapital;
